var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.56 14.01",
    style: {
      enableBackground: "new 0 0 14.56 14.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-chat",
    className: "st0",
    d: "M6.16,0.01c-3.24-0.15-6,2.36-6.16,5.6c0.01,1.56,0.71,3.03,1.9,4.03 c-0.21,0.64-0.61,1.19-1.16,1.58c-0.15,0.05-0.22,0.21-0.17,0.36c0.05,0.14,0.19,0.21,0.33,0.18c1.01-0.03,1.98-0.4,2.75-1.05 c0.36,0.15,0.72,0.26,1.1,0.34c-0.18-0.49-0.27-1-0.27-1.52c0.17-2.93,2.67-5.18,5.6-5.04c0.75,0,1.49,0.13,2.18,0.4 C11.72,1.97,9.12-0.1,6.16,0.01z M10.08,5.61C7.76,5.46,5.76,7.21,5.6,9.53c0.16,2.31,2.16,4.06,4.48,3.92 c0.57,0,1.13-0.1,1.67-0.28c0.72,0.53,1.58,0.82,2.47,0.84c0.15,0.03,0.3-0.07,0.33-0.22c0.03-0.13-0.05-0.27-0.17-0.32 c-0.45-0.32-0.8-0.76-1.04-1.26c0.76-0.68,1.21-1.66,1.22-2.68C14.4,7.21,12.4,5.46,10.08,5.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQA);
export default __webpack_public_path__ + "static/media/q_a.5ef75163a43bd08b0fbcc05bd3078914.svg";
export { ForwardRef as ReactComponent };